import React, { useState } from 'react';
import {
  RadioCardGroup,
  RadioCardOptionOrientation,
  RadioCardSizing,
} from '../../../../../../../core';
import { LocationOptions } from '../../../../../../../utils';
import { FormDialog } from '../../../../../../../core/components/dialogs/formDialog';

export interface LocationChoiceDialogProps {
  isOpen: boolean;
  locationId: string;
  locationList: LocationOptions[];
  onClose: () => void;
  onLocationPicked: (locationId: string) => void;
}

const LocationChoiceDialog: React.FC<LocationChoiceDialogProps> = (
  props: LocationChoiceDialogProps
) => {
  const [selectedLocationId, setSelectedLocationId] = useState<string>(
    props.locationId
  );

  const locationOptions = props.locationList;

  const onLocationPicked = (locationId: string) => {
    setSelectedLocationId(locationId);
  };

  const onSelectLocation = () => {
    if (selectedLocationId.length > 0) {
      props.onLocationPicked(selectedLocationId);
    }
  };

  return (
    <FormDialog
      title="Filter your results"
      isOpen={props.isOpen}
      onDismiss={props.onClose}
      actionButton={{ caption: 'Select Location', onClick: onSelectLocation }}
    >
      <RadioCardGroup
        label="Select location"
        required={true}
        validate={false}
        groupName="selectLocation"
        sizing={RadioCardSizing.Auto}
        orientation={RadioCardOptionOrientation.Vertical}
        radioOptions={locationOptions}
        selectedValue={selectedLocationId}
        onChange={onLocationPicked}
      />
    </FormDialog>
  );
};

export default LocationChoiceDialog;
